"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsPageReporter = void 0;
var app_utils_1 = require("@sixfold/app-utils");
var typed_primitives_1 = require("@sixfold/typed-primitives");
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var context_1 = require("./context");
function findMatchingRoute(routes, path) {
    var matches = routes
        .map(function (_a) {
        var tracking = _a.tracking, routerPath = _a.routerPath;
        if (tracking === undefined) {
            return undefined;
        }
        var match = (0, react_router_dom_1.matchPath)(path, { path: routerPath, exact: true });
        if (match === null) {
            return undefined;
        }
        return {
            tracking: tracking,
            match: match,
        };
    })
        .filter(typed_primitives_1.notNil);
    if (matches.length === 0) {
        return undefined;
    }
    return matches[0];
}
function pickDefinedParameters(params) {
    return (0, typed_primitives_1.pickBy)(params, typed_primitives_1.notNil);
}
var AnalyticsPageReporter = function (_a) {
    var routes = _a.routes;
    var analytics = (0, context_1.useAnalytics)();
    var location = (0, react_router_dom_1.useLocation)();
    var lastReportedPage = React.useRef();
    React.useEffect(function () {
        var _a;
        if (analytics === undefined) {
            // Avoid doing any logic if we don't yet have analytics initialised
            return;
        }
        var match = findMatchingRoute(routes, location.pathname);
        if (match !== undefined) {
            var mapQueryParameters = (_a = match.tracking.queryParamsToProperties) !== null && _a !== void 0 ? _a : pickDefinedParameters;
            var reportedPage = {
                name: match.tracking.name,
                properties: __assign(__assign(__assign(__assign({}, (window !== undefined ? { url: window.location.href } : {})), mapQueryParameters((0, app_utils_1.getQueryParameters)(location.search))), match.match.params), (match.tracking.category !== undefined ? { category: match.tracking.category } : {})),
            };
            // Avoid double reporting events in case some other dependencies change
            if (!(0, typed_primitives_1.deepEqual)(lastReportedPage.current, reportedPage)) {
                analytics.page(reportedPage.name, reportedPage.properties);
                lastReportedPage.current = reportedPage;
            }
        }
    }, [analytics, routes, location.search, location.pathname]);
    return null;
};
exports.AnalyticsPageReporter = AnalyticsPageReporter;
//# sourceMappingURL=page_reporter.js.map